import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import { Box, IconButton } from '@material-ui/core';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';

import { IIcd10CodeList } from '~/services/api/icd10Codes/types';
import { Order } from '~/types';
import { getSort } from '~/utils/sort';
import { ISort } from '~/utils/sort/types';
import NoDataFound from '~/ui/components/reusable/NoDataFound';
import { headCells } from './constants';

import styles from './Table.module.scss';

interface IProps {
  items: IIcd10CodeList[];
  sort: ISort;
  setSort: (sort: ISort) => void;
  onEdit: (diagnosis: IIcd10CodeList) => void;
  onDelete: (item: IIcd10CodeList) => void;
}

const TableComponent = ({ items, sort, setSort, onEdit, onDelete }: IProps) => (
  <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          {headCells.map(headCell => (
            <TableCell key={headCell.id} width={headCell.width}>
              {headCell.useSort ? (
                <TableSortLabel
                  active={sort.orderBy === headCell.id}
                  direction={
                    sort.orderBy === headCell.id && sort.isDescending ? Order.Desc : Order.Asc
                  }
                  onClick={() => setSort(getSort(sort, headCell.id))}
                >
                  {headCell.label}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {items.length > 0 ? (
          items.map(item => (
            <TableRow key={item.id}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>{item.createdByUserFullName}</TableCell>
              <TableCell>
                <Box className={styles.actions}>
                  <IconButton title="Edit" color="primary" onClick={() => onEdit(item)}>
                    <CreateIcon />
                  </IconButton>

                  <IconButton title="Retire" color="secondary" onClick={() => onDelete(item)}>
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={4}>
              <NoDataFound />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TableComponent;
